import React, { useState } from "react"
import Header from "../../components/common/Header"
import ThemaSearch from "../../components/System/ThemaSearch"
import ThemaResult from "../../components/System/ThemaResult"

import { useThemaApi } from "../../hooks/useSampleApi"
import { Container } from "../../components/common/System"

const ThemaPage = () => {
  const [searchWord, setSearchWord] = useState({'search':''})
  const formHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const target = e.currentTarget as HTMLButtonElement
    setSearchWord({'search': target.value})
  }
  
  const {data, mutate, isLoading} = useThemaApi()

  const submitHandler = () => {
    console.log(searchWord)
    mutate(searchWord)
  }

  if (isLoading) {
    return (
      <div>
        <h2>Loading...</h2>
      </div>
    )
  } else {
    return (
      <>
        <Header />
        <Container>
          <ThemaSearch
            searchWord = {searchWord}
            formHandler={formHandler}
            submitHandler={submitHandler} />
          <ThemaResult data={data}/>
        </Container>
      </>
    )
  }

}

export default ThemaPage